// extracted by mini-css-extract-plugin
export default {"addButton":"CollectionsView_addButton__n9naT","addCard":"CollectionsView_addCard__3ncyl"};